import { getComponentMaxWidthManifestFields } from '~/utils/manifest-utils';

const manifest = {
  api: {},
  plugin_id: 1181,
  dependency_repository_url: [],
  dependency_name: '',
  author_name: 'Applicaster',
  author_email: 'zapp@applicaster.com',
  name: 'Group',
  description: 'Group',
  type: 0,
  screen: false,
  react_native: true,
  identifier: 'group-qb',
  ui_builder_support: true,
  whitelisted_account_ids: [],
  deprecated_since_zapp_sdk: '',
  unsupported_since_zapp_sdk: '',
  targets: ['web'],
  ui_frameworks: ['quickbrick'],
  platform: 'web',
  dependency_version: '1.0.1',
  manifest_version: '1.0.3',
  min_zapp_sdk: '0.0.1',
  styles: {
    fields: [
      {
        group: true,
        label: 'Component max width',
        folded: false,
        fields: [...getComponentMaxWidthManifestFields()],
      },
      {
        group: true,
        label: 'Component configuration',
        folded: false,
        fields: [
          {
            key: 'group_margin_top',
            label: 'Component Margin Top',
            initial_value: 0,
            type: 'number_input',
          },
          {
            key: 'group_margin_bottom',
            label: 'Component Margin Bottom',
            initial_value: 0,
            type: 'number_input',
          },
          {
            key: 'group_padding_left',
            label: 'Component Padding Left',
            initial_value: 0,
            type: 'number_input',
          },
          {
            key: 'group_padding_right',
            label: 'Component Padding Right',
            initial_value: 0,
            type: 'number_input',
          },
          {
            key: 'group_padding_top',
            label: 'Component Padding Top',
            initial_value: 0,
            type: 'number_input',
          },
          {
            key: 'group_padding_bottom',
            label: 'Component Padding Bottom',
            initial_value: 0,
            type: 'number_input',
          },
          {
            key: 'group_background_color',
            label: 'Component Background Color',
            initial_value: 'rgba(0, 0, 0, 0)',
            type: 'color_picker_rgba',
          },
        ],
      },
    ],
  },
  rules: {
    fields: [
      {
        key: 'hide_component_if_data_is_empty',
        label: 'Hide component if data is empty',
        initial_value: false,
        type: 'switch',
      },
      {
        key: 'repeat_pattern_type',
        label: 'Repeat pattern',
        options: [
          { text: 'No Repeat', value: 'no' },
          { text: 'Repeat all components', value: 'all' },
          { text: 'Repeat last X components', value: 'last' },
        ],
        initial_value: 'no',
        type: 'select',
      },
      {
        key: 'repeat_num_of_components',
        label: 'X Amount',
        label_tooltip:
          'You can choose if you want to repeat the pattern of\n      the components you set in the group multiple times.\n        \u003cbr/\u003e\n        \u003cbr/\u003e\n        You choose one of the following options:\n        \u003cbr/\u003e\n        **No Repeat** - the group will show up only once\n        \u003cbr/\u003e\n        **Repeat all components** -\n        the pattern of the group will repeat till the end of the data source\n        \u003cbr/\u003e\n        ~~**Repeat first X components** -~~\n        \u003cbr/\u003e\n        **Repeat last  X components** -\n        the group will show all its items once and then repeat only the lats\n        X amount of the components till the items in the data source end.',
        initial_value: 1,
        conditional_fields: [
          {
            key: 'rules/repeat_pattern_type',
            condition_value: ['all', 'last'],
          },
        ],
        type: 'number_input',
      },
      {
        key: 'enable_data_refreshing',
        label: 'Enable data refreshing',
        initial_value: false,
        type: 'switch',
      },
      {
        key: 'refreshing_interval',
        label: 'Refreshing interval',
        initial_value: 0,
        conditional_fields: [
          { key: 'rules/enable_data_refreshing', condition_value: true },
        ],
        type: 'number_input',
      },
      {
        key: 'load_feed_from_client',
        label: 'Load feed from the client',
        initial_value: false,
        type: 'switch',
      },
      {
        group: true,
        label: 'Advanced Configuration',
        folded: true,
        fields: [
          {
            key: 'clear_cache_on_reload',
            initial_value: false,
            label: 'Clear cache on reload',
            type: 'switch',
            label_tooltip:
              'Enable this option to clear the cache every time the screen is loaded. This can be useful when the content changes frequently and you want to make sure the latest version is always displayed. Please note this will disable caching for the entire screen.',
          },
        ],
      },
    ],
  },
  data: { fields: [{ key: 'source', label: 'Source', type: 'text_input' }] },
  characteristics: {
    group: true,
    appearance: ['screen'],
    skip_cell_styles_selector: true,
  },
} as const;

export default manifest;
